/* eslint-disable react/no-array-index-key */
import Box from '@material-ui/core/Box';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectVirtualConsult } from '../../../VirtualConsult/selectors';
import { verifyAuthenticationCode } from '../../../VirtualConsult/virtualConsultSlice';

function VerificationCode(props) {
  const { actions, field } = props;

  const consult = useSelector(selectVirtualConsult);

  const [values, setValues] = useState([]);
  const [isError, setError] = useState(false);
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [formattedContact, setFormattedContact] = useState();

  const dispatch = useDispatch();

  const refs = useRef([...Array(6)]);

  const handleChange = (e, index) => {
    const value = e.target.value ? Math.max(0, parseInt(e.target.value)).toString().slice(0, 1) : '';
    const updatedValues = [...values];
    updatedValues[index] = value;
    setValues(updatedValues);

    if (value && index + 1 <= refs.current.length - 1) {
      refs.current[index + 1].focus();
    }
  };

  const onKeyDown = (e, index) => {
    setError(false);

    const currentValue = values[index];
    if ((e.keyCode === 8 || e.keycode === 46) && !currentValue && index - 1 >= 0) {
      refs.current[index - 1].focus();
    }
  };

  const getResult = () => values.join('');

  const clearInputs = () => {
    setValues([]);
  };

  // Check if full sequence is complete and send to API for verification
  useEffect(() => {
    if (values.length === 6) {
      // Get tenant id from URL
      const currentTenant = window.location.href.split('/')[3];
      const code = getResult();
      const verifyData =
        field.type === 'phoneCode' ? { Source: phone, numericCode: code } : { Source: email, numericCode: code };
      dispatch(verifyAuthenticationCode(verifyData, field.type, currentTenant));
    }
    // eslint-disable-next-line
  }, [values, actions, phone]);

  useEffect(() => {
    // Once available to the component, take the phone number that was previously provided by the user and format it for display
    if (field.type === 'phoneCode') {
      const { phoneNumber } = consult.previewQuestion.question.question;
      setPhone(phoneNumber);
      const cleaned = `${phoneNumber}`.replace(/\D/g, '');
      // Verify format
      const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        const intlCode = match[1] ? '+1 ' : '';
        setFormattedContact([intlCode, '(', match[2], ') ', match[3], '-', match[4]].join(''));
      }
    } else if (field.type === 'emailCode') {
      setFormattedContact(consult.previewQuestion.question.question.email);
      setEmail(consult.previewQuestion.question.question.email);
    }
    // After code is found invalid, activate error
    if (consult.invalidCode) {
      setError(true);
      clearInputs();
    }
  }, [
    consult.invalidCode,
    consult.previewQuestion.question.question.phoneNumber,
    consult.previewQuestion.question.question.email,
    field.type,
  ]);

  return (
    <Grid>
      <h2>Enter the secure code we sent you</h2>

      <Typography>We sent a 6 digit code to you at</Typography>
      <Typography>{formattedContact}</Typography>
      <Box>
        <Grid container spacing={2}>
          {refs.current.map((item, index) => (
            <Grid key={index} item xs={2}>
              <TextField
                inputRef={(ref) => {
                  refs.current[index] = ref;
                }}
                id="number"
                type="first_input"
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus={index === 0}
                value={values[index] || ''}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => onKeyDown(e, index)}
                variant="outlined"
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      {isError ? <FormHelperText error>Invalid Code</FormHelperText> : null}
    </Grid>
  );
}

export default VerificationCode;
